import $ from "jquery";
import { useState } from "preact/hooks";

import stores from "stores/stores";

type SoundEffect = "correct" | "incorrect" | "session-complete";

/** Map of sound effect key to base 64 data URI, used for caching within the current session */
const soundEffectData: { [soundEffect: string]: string } = {};

const fetchSoundEffectURI = async (soundEffect: SoundEffect) => {
  const existingDataURI = soundEffectData[soundEffect];

  if (existingDataURI) {
    return existingDataURI;
  }

  // Fetch the sound effect from the server and store it as a base64 data URI
  const response = await fetch(`/content/sounds/${soundEffect}.mp3`);

  const dataURI = await response.blob().then((blob) => {
    return new Promise<string>((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(reader.result as string);
      reader.readAsDataURL(blob);
    });
  });

  soundEffectData[soundEffect] = dataURI;

  return dataURI;
};

export const SoundEffectView = ({
  soundEffect,
}: {
  soundEffect: SoundEffect;
}) => {
  if (!stores.user.state.value.soundEffectsEnabled) {
    return null;
  }

  const [soundEffectURI, setSoundEffectURI] = useState<string | undefined>(
    undefined
  );

  fetchSoundEffectURI(soundEffect).then((uri) => {
    setSoundEffectURI(uri);
  });

  if (soundEffectURI === undefined) {
    return null;
  }

  return (
    <audio autoPlay>
      <source src={soundEffectURI} type="audio/mpeg" />
    </audio>
  );
};

export const play = async (soundEffect: SoundEffect) => {
  if (!stores.user.state.value.soundEffectsEnabled) {
    return;
  }

  const soundEffectURI = await fetchSoundEffectURI(soundEffect);

  // Remove existing sound effect element
  $("#sound-effect").remove();

  // Add new sound effect element
  $(document.body).append(
    $(`
    <audio id="sound-effect" autoPlay>
      <source src="${soundEffectURI}" type="audio/mpeg" />
    </audio>`)
  );
};
